module.exports = __webpack_public_path__ + "static/media/asset2.aaf9abb5.svg";